import { createStyles } from '@mantine/core';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import Text from '../Text/Text';

const useTagNumStyles = createStyles(() => {
  return {
    dialog_num: {
      display: 'block',
      backgroundColor: COLORS_FLAT.n200,
      borderRadius: 4,
      padding: '0 6px',
    },
  };
});

export function TagNum(props: React.HTMLAttributes<HTMLSpanElement>) {
  const { children, className, ...rest } = props;
  const { classes, cx } = useTagNumStyles();
  const cxClass = cx(classes.dialog_num, className);
  return (
    <Text<'span'> text="h200" className={cxClass} {...rest} span>
      {children}
    </Text>
  );
}
